import { makeStyles } from '@mui/styles';
import classNames from 'classnames';
import React from 'react';

import { useFormSelector } from '../../custom-hooks';
import { getUITA } from '../../utils/commonUtils';
import { FCM_BORDER_STYLES } from '../constants/runtime.constants';
import { SubGridContext } from '../context';
import DynamicField from '../DynamicField';
import { getIsFormChangesMode } from '../selectors/common.selectors';
import { getIsControlAdded } from '../selectors/form-manager.selectors';
import { getIndexForControlsInsideTable } from '../utils/form-manager.utils';

const useStyles = makeStyles({
  root: {
    display: 'inline-block',
    width: '100%',
    padding: 10,
  },
  changesModeWrapper: {
    display: 'block',
    marginTop: ({ useExpandableRows }) => (useExpandableRows ? 8 : 0),
    marginBottom: 8,
    padding: 8,
    border: FCM_BORDER_STYLES.GREEN,
  },
});

const SSSubGrid = ({ row, subgridId, index, isDetail, viewOnly, isParentlessTable }) => {
  const classes = useStyles({ useExpandableRows: row.useExpandableRows });
  const isAdded = useFormSelector(getIsControlAdded, { id: subgridId });
  const isFormChangesMode = useFormSelector(getIsFormChangesMode);

  const rowIndex = isParentlessTable ? row.gridArrIndex : row.index;
  const gridArrIndex = getIndexForControlsInsideTable(index, rowIndex, isParentlessTable);

  const component = (
    <span
      className={classNames({
        [classes.root]: true,
        [classes.changesModeWrapper]: isAdded && isFormChangesMode,
      })}
      ui-ta={getUITA('FormCtrl', 'SubGrid', row.entityName)}
      id={`${subgridId}#[${gridArrIndex}]`}
      data-subgrid-expanded={row.expanded}
      data-ss-id={subgridId}
    >
      <DynamicField
        id={subgridId}
        index={gridArrIndex}
        isDetail={isDetail}
        isParentViewOnly={viewOnly}
      />
    </span>
  );

  return row.useExpandableRows ? (
    component
  ) : (
    <SubGridContext.Provider value={true}>{component}</SubGridContext.Provider>
  );
};

export default SSSubGrid;
